<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :toPdf="eleToPdf"></MulReportHeader>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px" ref="tableRef"></Table>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
export default {
    name: 'HandicapRRStatistics',
    components: { MulReportHeader },
    data() {
        return {
            loading: false,
            TransTopReqTimer: null,
            timestamp: 0,
            mean: this.initMean(),
            table: {
                params: {
                    platids: [],
                    app_ids: [],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                columns: [
                    { type: 'index', title: '序号', align: 'center', width: 60 },
                    { key: 'app_name', width: 110, align: 'center', renderHeader: (h) => this.renderHeader(h, '盘口', '显示对应的盘口名称') },
                    {
                        key: 'new_win_rate',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '营收比', '筛选时间内,盘口(【今日转入】-【今日转出】+【昨日余额】-【今日余额】) /【转入金额】'),
                        render: (h, params) => h('span', params.row.new_win_rate === -1 ? '-' : (params.row.new_win_rate * 100 || 0).toFixed(2) + '%')
                    },
                    this.renderCol('zhuan_rate', '新增转化率', '筛选时间内,盘口新增转入人数 / 新增人数'),
                    this.renderCol('pay_winner_rate', '转入赢家数占比', '筛选时间内,盘口转入赢家数占比'),
                    this.renderCol('new_ci_ri_pay_rate', '新增转入次日复充率', '筛选时间内,盘口昨日新增转入用户，在第二天有转入行为的比例'),
                    this.renderCol('ci_ri_pay_rate', '平台转入用户次日复充', '筛选时间内,盘口转入用户，在当日有转入行为的比例')
                    // this.renderCol('online_pay_rate', '线上转入成功率', '筛选时间内,盘口线上转入成功率 = 成功转入订单数/提交转入订单数'),
                ]
            }
        }
    },
    methods: {
        //查询数据
        searchData(emitProps) {
            let allList = this.getAllHttpAppid(this.table.params)
            let httpList = []
            let loadingArr = [...allList]
            // // GetRebateActiveData
            let stime = this.getSecond(this.table.params.dataTime)
            let etime = this.getSecond(this.table.params.dataTime, false)
            this.timestamp = new Date().getTime() //设置请求时间
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let app_name = ''
                let platid = 0
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                let el = { platid, app_id, app_name }
                let param = this.getTransTopParams('GetNewPlatfromData', { platid, app_id, app_name, stime, etime, general: -1, pack_no: -1, page: 1, limit: 10000, sort: 0, timestamp: this.timestamp })
                httpList.push(param)
            }
            // // GetRebateActiveData, GetUserActiveData, GetUserCompleteActiveData, GetZhuanPanActiveData, GetZhuanPanPutData, GetZhuanPanUserData, GetUserCoinRecord, GetUserVipCoinRecord, GetOneUserActiveData
            this.mean = this.initMean()

            this.table.data = []
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, loadingArr)
            }
        },
        async toHttp(httpList, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                if (this.isCurrentHttp(param.timestamp)) {
                    this.openTimer()
                    let canNext = true
                    //请求平台数据
                    let res = await TransTopReq(param)
                    canNext = this.isCurrentHttp(param.timestamp) && !!res._param
                    let data = {}
                    if (canNext) {
                        data = res._param.data[0]
                        data.online_pay_rate = this.calcRate(data.online_pay_success_num, data.online_pay_all_num)
                        data.app_name = param.app_name
                    }
                    let params1 = this.copyData(param)
                    if (canNext) {
                        //请求新增留存数据
                        params1.param._func = 'GetNewPlatfromNewPayInfo'
                        params1.param._param.stime = parseInt((params1.param._param.stime - 24 * 60 * 60).toFixed(0))
                        params1.param._param.etime = parseInt((params1.param._param.etime - 24 * 60 * 60).toFixed(0))
                        let res1 = await TransTopReq(params1)
                        canNext = this.isCurrentHttp(param.timestamp) && !!res1._param
                        if (canNext) {
                            let data1 = res1._param.data[0] || {}
                            data.new_ci_ri_pay_rate = data1.ci_ri_pay_rate || 0 //新增次日复充率
                            data.new_ci_ri_pay_num = data1.ci_ri_pay_num || 0 // 新增次日复充人数
                            data.new_ci_ri_all_pay_num = data1.new_user_pay_num || 0 //新增首充人数
                        }
                    }

                    if (canNext) {
                        //请求留存数据
                        let params2 = this.copyData(params1)
                        params2.param._func = 'GetNewPlatformRepeatPayInfo'
                        let res2 = await TransTopReq(params2)
                        canNext = this.isCurrentHttp(param.timestamp) && !!res2._param
                        if (canNext) {
                            let data2 = res2._param.data[0] || {}
                            data.ci_ri_pay_rate = data2.ci_ri_pay_rate || 0 //转入次日复充率
                            data.ci_ri_pay_num = data2.ci_ri_pay_num || 0 // 转入次日复充人数
                            data.ci_ri_all_pay_num = data2.user_pay_num || 0 //转入首充人数
                        }
                    }
                    if (canNext) {
                        this.mean.new_win_sum += data.new_win_sum //累计均值营收金额
                        this.mean.pay_sum += data.pay_sum //累计均值转入金额
                        this.mean.new_user_num += data.new_user_num //累计均值新增人数
                        this.mean.new_user_pay_num += data.new_user_pay_num //累计均值新增转入人数
                        this.mean.online_pay_all_num += data.online_pay_all_num //累计均值订单数
                        this.mean.online_pay_success_num += data.online_pay_success_num //累计均值订单成功数
                        this.mean.new_ci_ri_pay_num += data.new_ci_ri_pay_num //累计均值新增次日转入人数
                        this.mean.new_ci_ri_all_pay_num += data.new_ci_ri_all_pay_num //累计均值新增转入人数
                        this.mean.ci_ri_pay_num += data.ci_ri_pay_num //累计均值转入留存次日转入人数
                        this.mean.ci_ri_all_pay_num += data.ci_ri_all_pay_num //累计均值转入留存转入人数
                        this.mean.pay_winner += data.pay_winner
                        this.mean.pay_win_loser += data.pay_loser + data.pay_winner
                        this.mean.new_ci_ri_pay_rate = this.calcRate(this.mean.new_ci_ri_pay_num, this.mean.new_ci_ri_all_pay_num) //新增转入复充率
                        this.mean.ci_ri_pay_rate = this.calcRate(this.mean.ci_ri_pay_num, this.mean.ci_ri_all_pay_num) //转入复充率
                        this.mean.online_pay_rate = this.calcRate(this.mean.online_pay_success_num, this.mean.online_pay_all_num) //成功率
                        this.mean.new_win_rate = this.calcRate(this.mean.new_win_sum, this.mean.pay_sum) //营收比
                        this.mean.zhuan_rate = this.calcRate(this.mean.new_user_pay_num, this.mean.new_user_num) //新增转化率
                        this.mean.pay_winner_rate = this.calcRate(this.mean.pay_winner, this.mean.pay_win_loser) //新增转化率
                    }
                    if (this.isCurrentHttp(param.timestamp)) {
                        loadingArr.shift()
                        if (httpList.length > 0) {
                            this.toHttp(httpList, loadingArr)
                        }
                        this.table.data.shift()
                        let result = [this.mean, ...this.table.data, data]
                        this.table.data = result
                    }
                }
            }
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                timestamp: param.timestamp,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: { ...param }
                }
            }
        },

        //初始化均值
        initMean() {
            return {
                app_id: -10,
                plat_form_name: '',
                app_name: '均值',
                new_user_num: 0, //新增人数
                pay_win_loser: 0,
                new_user_pay_num: 0, //新增转入人数
                pay_sum: 0, // 转入金额
                new_win_pay: 0, //
                new_win_rate: 0, //营收比= 营收金额/转入金额
                game_loss_sum: 0, //游戏盈亏
                zhuan_rate: 0, //新增转化率
                pay_winner: 0, //转入赢家人数
                pay_loser: 0, //转入输家数
                pay_winner_rate: 0, //转入赢家数占比
                money_win_rate: 0, //实钱赢家数占比
                send_total_percent_sum: 0, //佣金
                new_ci_ri_pay_rate: 0, //新增转入次日复充率
                new_ci_ri_pay_num: 0, //新增转入次日复充人数
                new_ci_ri_all_pay_num: 0, //转入次日首充人数
                ci_ri_pay_rate: 0, //转入次日复充率
                ci_ri_pay_num: 0, //转入次日复充人数
                ci_ri_all_pay_num: 0, //转入次日首充人数

                money_loss_rate: 0, //佣金转入比  佣金/转入
                new_win_sum: 0, //营收金额=今日转入-今日转出+昨日余额-今日余额
                online_pay_all_num: 0, // 线上转入总订单数
                online_pay_success_num: 0, // 线上转入成功订单数
                online_pay_rate: 0 //线上转入成功率
            }
        },
        renderCol(key, title, tip, minWidth = 80) {
            return {
                key,
                minWidth: 80,
                align: 'center',
                renderHeader: (h) => this.renderHeader(h, title, tip),
                render: (h, params) => h('span', (params.row[key] * 100 || 0).toFixed(2) + '%')
            }
        },
        isCurrentHttp(timestamp) {
            return timestamp == this.timestamp
        }
    }
}
</script>

<style scoped lang="less"></style>
